import { makeStorageProxy } from './makeStorage';

export const LocalStorage = makeStorageProxy(window.localStorage);
export const SessionStorage = makeStorageProxy(window.sessionStorage);
